export default {
      id: "contact-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#contact",
      toString: function () {
        return this.url;
      }
    }